import { Area, AreaChart, Brush, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { convertDate, renderColorfulLegendText } from "../../util/Util";

const PrecipChart = ({ chartData, type, startYear, endYear }) => {

    return (
        <>
            {type === "5 Years" ?
                <ResponsiveContainer width={"100%"} height="100%">
                    <AreaChart
                        data={chartData}
                        margin={{ top: 25, right: 30, bottom: 35 }}
                    >
                        <CartesianGrid strokeDasharray="0.5 0.5" />
                        <XAxis
                            angle={45}
                            textAnchor="start"
                            dataKey="dayMonth"
                            stroke="rgba(255,255,255,1)"
                            type="category"
                            allowDuplicatedCategory={false}
                        />
                        <YAxis unit=" mm"
                            type="number"
                            // domain={["0", "dataMax + 100"]}
                            stroke="white" />
                        <Tooltip cursor={{ fill: 'transparent' }}
                            wrapperStyle={{ color: "rgba(1, 28, 20, 0.74)" }}
                            itemStyle={{ color: "rgba(1, 28, 20, 0.74)" }}
                        />
                        <Legend verticalAlign="top" height={50} />

                        {chartData.map((eachSegment, key) => (
                            <Area
                                fillOpacity={0.3}
                                type="monotone"
                                dataKey="precipitation"
                                data={eachSegment?.data}
                                key={key}
                                name={`Year ${eachSegment?.year}`}
                                stroke={eachSegment?.color}
                                fill={eachSegment?.color}
                            />
                        ))}

                        <Brush
                            dataKey="date"
                            height={20}
                            stroke="blue"
                            y={400}
                            data={chartData}
                            gap={20}
                            style={{ marginTop: "20em" }}
                            travellerWidth={50}
                        />
                    </AreaChart>
                </ResponsiveContainer>
                :
                <>
                    {type === "None" ?
                        <ResponsiveContainer width={"100%"} height="100%">
                            <AreaChart
                                data={chartData}
                                margin={{ top: 15, right: 30, left: 20, bottom: 35 }}
                            >
                                <CartesianGrid strokeDasharray="1 1" />
                                <XAxis
                                    tickFormatter={convertDate}
                                    angle={45}
                                    textAnchor="start"
                                    dataKey="date"
                                    stroke="white"
                                />
                                <YAxis
                                    unit=" mm"
                                    stroke="white"
                                />
                                <Tooltip cursor={{ fill: 'transparent' }}
                                    wrapperStyle={{ color: "rgba(1, 28, 20, 0.74)" }}
                                    itemStyle={{ color: "rgba(1, 28, 20, 0.74)" }}
                                />
                                <Legend
                                    verticalAlign="top"
                                    formatter={() =>
                                        renderColorfulLegendText(
                                            "Precipitation - " + startYear + endYear,
                                            "white"
                                        )
                                    }
                                    height={50}
                                />

                                <Brush
                                    dataKey="date"
                                    height={20}
                                    stroke="blue"
                                    // x={0}
                                    y={400}
                                    data={chartData}
                                    gap={20}
                                    style={{ marginTop: "20em" }}
                                    travellerWidth={50}
                                />

                                <Area
                                    name="Precipitation"
                                    fillOpacity={0.7}
                                    type="monotone"
                                    dataKey="precipitation"
                                    stroke="rgba(255,255,255,0.5)"
                                    fill="#82ca9d"
                                />
                            </AreaChart>
                        </ResponsiveContainer>
                        : <ResponsiveContainer width={"100%"} height="100%">
                            <AreaChart
                                data={chartData}
                                margin={{ top: 15, right: 30, left: 20, bottom: 35 }}
                            >
                                <CartesianGrid strokeDasharray="1 1" />
                                <XAxis
                                    angle={45}
                                    textAnchor="start"
                                    dataKey="dayMonth"
                                    stroke="white"
                                />
                                <YAxis
                                    unit=" mm"
                                    stroke="white"
                                />
                                <Tooltip cursor={{ fill: 'transparent' }}
                                    wrapperStyle={{ color: "rgba(1, 28, 20, 0.74)" }}
                                    itemStyle={{ color: "rgba(1, 28, 20, 0.74)" }}
                                />
                                <Legend
                                    verticalAlign="top"
                                    formatter={() =>
                                        renderColorfulLegendText(
                                            "Average Precipitation - " + startYear + endYear,
                                            "white"
                                        )
                                    }
                                    height={50}
                                />

                                <Brush
                                    dataKey="dayMonth"
                                    height={20}
                                    stroke="blue"
                                    // x={0}
                                    y={400}
                                    data={chartData}
                                    gap={20}
                                    style={{ marginTop: "20em" }}
                                    travellerWidth={50}
                                />

                                <Area
                                    name="Precipitation"
                                    fillOpacity={0.7}
                                    type="monotone"
                                    dataKey="precipitation"
                                    stroke="rgba(255,255,255,0.5)"
                                    fill="#82ca9d"
                                />
                            </AreaChart>
                        </ResponsiveContainer>}
                </>
            }
        </>
    )
};

export default PrecipChart;